import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { LoginForm } from "@/components/LoginForm";
import { Board } from "@/components/Board";
import { getToken, getUser, getMe, setUser as persistUser, clearToken } from "@/lib/api";

function App() {
  const [user, setUser] = useState(getUser());
  const [checking, setChecking] = useState(!!getToken());

  useEffect(() => {
    if (!getToken()) { setChecking(false); return; }
    getMe()
      .then(({ data }) => { persistUser(data); setUser(data); })
      .catch(() => { clearToken(); setUser(null); })
      .finally(() => setChecking(false));
  }, []);

  const logout = () => { clearToken(); setUser(null); };

  if (checking) {
    return (
      <div className="App min-h-screen flex items-center justify-center">
        <Toaster theme="dark" position="top-right" richColors />
        <div className="font-mono text-xs text-slate-500">Loading…</div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster theme="dark" position="top-right" richColors />
      {user ? (
        <Board user={user} onLogout={logout} />
      ) : (
        <LoginForm onAuthed={setUser} />
      )}
    </div>
  );
}

export default App;
